<template>
  <v-dialog v-model="visible" width="500" persistent>
    <v-card>
      <v-card-title class="headline text-left">{{ title }}</v-card-title>

      <v-card-text color="red" class="text-left">{{ description }}</v-card-text>
      <v-text-field v-if="serious" class="mx-6" outlined dense v-model="deleteConfirmationText" label="Type 'delete' to confirm"></v-text-field>
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="green darken-1" text @click="deleteObject(false)">Cancel</v-btn>

        <v-btn color="red darken-1" text @click="deleteObject(true)" :disabled="serious && deleteConfirmationText.trim().toLowerCase() != 'delete' "> {{ confirmationButtonText || "Delete" }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DeleteConfirmationDialog",
  props: {
    visible: {
      type: Boolean, 
      default: false,
    },
    serious: {
      type: Boolean, 
      default: false,
    },
    title: {
      type: String, 
      default: "",
    },
    description: {
      type: String, 
      default: "",
    },
    confirmationButtonText: {
      type: String, 
      default: "",
    },
  },
  data() {
    return{ 
      deleteConfirmationText: "",
    }
  },
  methods: {
    // emit to parent and let them know that delete was agreed (true) or disagreed (false)
    deleteObject(confirm) {
      this.deleteConfirmationText = "";
      this.$emit('deleteObject', confirm);
    },
}
};
</script>
<style lang="css">
.headline {
    white-space:pre-wrap;
  word-break:break-word;
  text-align:left;
}
</style>
